'use client';

import { useEffect, useState } from 'react';

interface Stat {
  id: string;
  value: string;
  label: string;
}

const TrustSignals = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('trust-signals');
    if (element) observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, []);

  const stats: Stat[] = [
    {
      id: 'stat_sold',
      value: '500+',
      label: 'Cars Sold',
    },
    {
      id: 'stat_secure',
      value: '100%',
      label: 'Secure Payment',
    },
    {
      id: 'stat_verified',
      value: '100%',
      label: 'Verified Sellers',
    },
    {
      id: 'stat_rating',
      value: '4.9/5',
      label: 'Customer Rating',
    },
  ];

  return (
    <section data-component-id="src/app/homepage/components/TrustSignals.tsx:56:4" data-component-path="src/app/homepage/components/TrustSignals.tsx" data-component-line="56" data-component-end-line="77" data-component-file="TrustSignals.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20border-y%20border-border%20bg-card%22%7D" className="py-16 border-y border-border bg-card">
      <div data-component-id="src/app/homepage/components/TrustSignals.tsx:57:6" data-component-path="src/app/homepage/components/TrustSignals.tsx" data-component-line="57" data-component-end-line="76" data-component-file="TrustSignals.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22trust-signals%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%22%7D" id="trust-signals" className="max-w-7xl mx-auto px-6">
        <div data-component-id="src/app/homepage/components/TrustSignals.tsx:58:8" data-component-path="src/app/homepage/components/TrustSignals.tsx" data-component-line="58" data-component-end-line="75" data-component-file="TrustSignals.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20md%3Agrid-cols-4%20gap-12%22%7D" className="grid grid-cols-2 md:grid-cols-4 gap-12">
          {stats.map((stat, index) => (
            <div data-component-id="src/app/homepage/components/TrustSignals.tsx:60:12" data-component-path="src/app/homepage/components/TrustSignals.tsx" data-component-line="60" data-component-end-line="73" data-component-file="TrustSignals.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={stat.id}
              className={`text-center transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <p data-component-id="src/app/homepage/components/TrustSignals.tsx:67:14" data-component-path="src/app/homepage/components/TrustSignals.tsx" data-component-line="67" data-component-end-line="69" data-component-file="TrustSignals.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-5xl%20md%3Atext-6xl%20font-bold%20tracking-tighter%20mb-2%20text-foreground%22%7D" className="text-5xl md:text-6xl font-bold tracking-tighter mb-2 text-foreground">
                {stat.value}
              </p>
              <p data-component-id="src/app/homepage/components/TrustSignals.tsx:70:14" data-component-path="src/app/homepage/components/TrustSignals.tsx" data-component-line="70" data-component-end-line="72" data-component-file="TrustSignals.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20uppercase%20tracking-%5B0.2em%5D%20text-muted-foreground%20font-bold%22%7D" className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-bold">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
